export default class Header {
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        this.$navi = [].slice.call(document.querySelectorAll('.l-header__navi-item'));
        this.$sceneLink = document.querySelector('#l-header__navi .-scene');
        this.$subNavi = document.querySelector('#l-header__subNavi');
        this.$subNaviLink = [].slice.call(document.querySelectorAll('.l-header__subNavi-item'));

        //param
        this.isAnimate = false

    }
    init() {

        if (this.manager.param.displayType === 'sp') return;

        // ボタンのhover動作
        for (let i in this.$navi) {
            if(this.$navi[i].nodeType!=1) continue; // dom要素以外は処理止める
            this.$navi[i].addEventListener("mouseenter", () => {
                this.enter(i);
            })
            this.$navi[i].addEventListener("mouseleave", () => {
                this.leave(i);
            })
        }

        // サブナビの表示非表示
        this.$sceneLink.addEventListener("mouseenter", () => {
            this.open();
        })
        this.$sceneLink.addEventListener("mouseleave", () => {
            this.hide();
        })

        // サブナビのhover動作
        for (let i in this.$subNaviLink) {
            if(this.$subNaviLink[i].nodeType!=1) continue; // dom要素以外は処理止める
            this.$subNaviLink[i].addEventListener("mouseenter", () => {
                this.enterSubNavi(i);
            })
            this.$subNaviLink[i].addEventListener("mouseleave", () => {
                this.leaveSubNavi(i);
            })
        }

    }

    open() {
        TweenMax.killTweensOf(this.$subNavi);

        TweenMax.to(this.$subNavi, .6 ,{
            opacity: 1,
            ease: Power2.easeOut,
            onStart: () => {
                this.$subNavi.style.cursor = '';
                this.$subNavi.style.visibility = 'visible';
                this.$subNavi.style.pointerEvents = 'auto';
            },
        });
    }

    hide() {
        TweenMax.killTweensOf(this.$subNavi);

        TweenMax.to(this.$subNavi, .6 ,{
            opacity: 0,
            ease: Power2.easeOut,
            onStart: () => {
                this.$subNavi.style.cursor = 'default';
                this.$subNavi.style.pointerEvents = 'none';
            },
            onComplete: () => {
                this.$subNavi.style.visibility = 'hidden';
            },
        });
    }

    enter(index) {
        for (let i in this.$navi) {
            if (this.$navi[i].nodeType != 1) continue; // dom要素以外は処理止める
            if (i != index) {
                TweenMax.to(this.$navi[i], 1.2 ,{
                    opacity: .2,
                    ease: Power2.easeOut,
                });
            }
        }
    }

    leave(index) {

        for(let i in this.$navi) {
            if (this.$navi[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i != index) {
                TweenMax.to(this.$navi[i], 1.2, {
                    opacity: 1,
                    ease: Power2.easeOut,
                });
            }
        }
    }

    enterSubNavi(index) {
        for(let i in this.$subNaviLink) {
            if (this.$subNaviLink[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i != index) {
                TweenMax.to(this.$subNaviLink[i], 1.2, {
                    opacity: .2,
                    ease: Power2.easeOut,
                });
            }
        }
    }

    leaveSubNavi(index) {
        for(let i in this.$subNaviLink) {
            if (this.$subNaviLink[i].nodeType != 1) continue; // dom要素以外は処理止める
            if(i != index) {
                TweenMax.to(this.$subNaviLink[i], 1.2, {
                    opacity: 1,
                    ease: Power2.easeOut,
                });
            }
        }
    }
}
